import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { FancyDropdown, InlineTooltip } from 'apps/builder/components/settings/modal'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import Select from 'react-select'
import { WhiteLabelCheck, selectStyles } from 'apps/builder/components/shared'
import {
  sheetsSelector,
  mirrorFieldsAndScreenSelector,
  entriesSelector,
  activeFieldInTableSelector,
  mirrorFieldsAndScreenTableSelector,
  whiteLabelSelector,
} from 'apps/builder/store/selectors'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { updateEntry } from 'apps/builder/store/actions/entries'

export const MirrorField = ({
  guid,
  label,
  default: defaultValue,
  type,
  keyField,
  style,
  summary_entry,
}) => {
  const dispatch = useDispatch()
  const isTable = useSelector(activeFieldInTableSelector)
  const sheetsAndScreens = isTable
    ? useSelector(mirrorFieldsAndScreenTableSelector)
    : useSelector(mirrorFieldsAndScreenSelector)
  const isWhiteLabeled = useSelector(whiteLabelSelector)
  const allEntries = useSelector(entriesSelector)
  const [selectedSheet, setSelectedSheet] = useState(null)
  const [selectedFieldType, setSelectedFieldType] = useState('')
  const [fieldOptions, setFieldOptions] = useState([])

  useEffect(() => {
    if (selectedSheet) {
      const foundSheetAndEntries = sheetsAndScreens.find(({ sheet }) => {
        return sheet.id == selectedSheet.value
      })

      const { entries } = foundSheetAndEntries || {}

      const options = entries.map(entry => ({
        label: entry.label,
        value: entry.guid,
      }))
      setFieldOptions(options)
    }
  }, [selectedSheet])

  useEffect(() => {
    if (summary_entry && summary_entry.guid) {
      const foundEntry =
        allEntries.find(e => e.guid == summary_entry.guid) || {}

      const { sheet = {} } = sheetsAndScreens.find(
        ({ sheet = {}, childSheet = {} }) => {
          return (
            sheet.id == foundEntry.sheet_id ||
            foundEntry.sheet_id == childSheet.id
          )
        }
      )
      setSelectedSheet({
        label: sheet.description || sheet.placeholder,
        value: sheet.id,
      })
      setSelectedFieldType(foundEntry.type)
    }
  }, [])

  const screenOptions = sheetsAndScreens.map(({ sheet }) => {
    return { value: sheet.id, label: sheet.description || sheet.placeholder }
  })

  const sharedProps = {
    styles: selectStyles,
    classNamePrefix: 'react-select',
  }

  const mirrorScreenProps = {
    ...sharedProps,
    options: screenOptions,
    value: selectedSheet,
    className: 'mirror-dropdown',
    disabled: !screenOptions.length,
    onChange: value => {
      setSelectedSheet(value)
      dispatch(
        updateEntry({
          guid,
          summary_entry: null,
        })
      )
      getSelectedFieldType({ guid: null })
    },
    isDisabled: !screenOptions.length,
  }

  const getSelectedFieldType = ({ guid }) => {
    if (guid) {
      const { type } = allEntries.find(e => e.guid == guid)
      setSelectedFieldType(type)
    } else {
      setSelectedFieldType('')
    }
  }
  const getSelectedFieldOption = () => {
    if (summary_entry && summary_entry.guid) {
      const { guid, label } = allEntries.find(e => e.guid == summary_entry.guid)

      return { label, value: guid }
    }
    return { label: null, value: null }
  }

  const mirrorFieldProps = {
    ...sharedProps,
    options: fieldOptions,
    value: getSelectedFieldOption(),
    className: 'mirror-dropdown',
    onChange: ({ value }) => {
      dispatch(
        updateEntry({
          guid,
          summary_entry: { guid: value },
        })
      )
      getSelectedFieldType({ guid: value })
    },
    isDisabled: !selectedSheet || !fieldOptions.length,
  }

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
          style={style}
        />
      </div>
      <div className="settings--row no-border">
        <div className="mirror-dropdown-wrapper">
          <div className="tooltip-group">
            <InlineTooltip
              tooltip={
                <>
                  Choose the screen that contains the field you want to mirror.
                  <WhiteLabelCheck>
                    <a
                      href="https://help.gocanvas.com/hc/en-us/articles/22596998586135-Configuring-Mirror-Fields-in-the-Builder"
                      target="blank"
                    >
                      Help
                    </a>
                  </WhiteLabelCheck>
                </>
              }
              icon={faInfoCircle}
              direction={`bottom`}
            />
          </div>
          <div>
            <FancyDropdown label={'Mirror from which screen?'}>
              <Select {...mirrorScreenProps} />
            </FancyDropdown>
          </div>

          <FancyDropdown label={'Mirror from which field?'}>
            <Select {...mirrorFieldProps} />
          </FancyDropdown>
          {selectedFieldType !== '' ? (
            <div className="info--block--container">
              <div className="info--block">
                <strong>{`Mirror Field Type: ${selectedFieldType}`}</strong>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  )
}
